var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.level != 0
    ? _c("div", { staticClass: "mb4 gwnl-web-position-skills-progress" }, [
        _c(
          "div",
          {
            staticClass:
              "gwnl-web-position-skills-progress-wrapper gwnl-web-position-skills-progress",
          },
          [
            _c("div", {
              staticClass:
                "bg-primary-6 mr8 gwnl-web-position-skills-progress-content",
              style: { width: _vm.level * 10 + "%", background: _vm.color },
            }),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "color-gray-9 standard-size-12 gwnl-web-position-skills-progress-index",
          },
          [
            _c(
              "yxt-tooltip",
              {
                attrs: {
                  effect: "dark",
                  "open-filter": "",
                  content: _vm.levelName,
                  placement: "top",
                },
              },
              [
                _c("span", { staticClass: "ellipsis levelName_maxWidth" }, [
                  _vm._v(_vm._s(_vm.levelName)),
                ]),
              ]
            ),
            _c("span", [
              _vm._v(
                _vm._s(
                  "（" + (_vm.range4show ? _vm.range4show : _vm.level) + "）"
                )
              ),
            ]),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }